export default {
    url: 'home-battery',
    include: ['jp'],
};
